import React, {useRef, useState} from "react";
import MaterialTable from "material-table";
import {useHistory, useLocation} from "react-router-dom";
import {deleteMember} from "../../api/RestCallHelper";
import {ErrorPage} from "../../shared/ErrorPage";
import LoadingIcon from "../../shared/LoadingIcon";
import {tableIcons} from "../../shared/MaterialTableIcons";
import {ROUTES} from "../../utils/RouteConstants";
import {ROLES} from "../../api/Constants";
import MemberTableDetailPanel from "./members-table-detail-panel/MembersTableDetailPanel";
import {NarrowButton} from "../../styles/globalStyles";
import {useFetchMembers} from "./hooks";
import FetchState from "../../api/FetchState";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import useUserData from "../../hooks/useUserData";
import {NarrowButtonWrapper} from "./MembersTableStyles"

const tableHeaders = {
    columns: [
        { title: "Member No.", field: "membershipId" },
        { title: "Name", field: "name" },
        { title: "Surname", field: "surname" },
        { title: "Claimed", field: "claimed", type:"boolean" },
        { title: "Donate Balance", field: "donateBalanceToScheme", type : "boolean" },
        { title: "Email Address", field: "email" },
        { title: "Cell Number", field: "cellNumber" },

    ]
};

export default function MembersTable() {

  const user = useUserData();

  let history = useHistory();
  let location = useLocation();

  const [data, fetchState] = useFetchMembers();
  const dispatch = useFeedbackDispatch();

  const [members, setMembers] = useState([]);

  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const close = (event, reason) => {
    console.log("In Members Screen close callback");
    if (reason === 'clickaway') return;

    dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
  };

  if (FetchState.SUCCESS === fetchState) {
    return (<>
        <br/>
        <br/>
        <MaterialTable
          title="Members"
          icons={tableIcons}
          columns={tableHeaders.columns}
          data={data}
          actions = { user.role.id <= ROLES.ADMIN && [{
                icon: tableIcons.Edit,
                tooltip: "Edit Member",
                onClick: (event, rowData) => {
                  history.push(ROUTES.MEMBERS_FORM, { member: {...rowData, tableData: null}, edit: true })
                }
              }]}
          editable = { user.role.id <= ROLES.ADMIN && {
            onRowDelete: (oldData) =>
              new Promise((resolve, reject) => {
                // don't send again while we are sending
                if (isSending) return;

                // update state
                setIsSending(true);

                // send the actual request
                deleteThisRow(oldData);
                async function deleteThisRow(data){
                  const success = await deleteMember(data.id, dispatch, close, history, location);
                  if(success === true) resolve();
                  else reject();
                }
              }).then(() => {
                // once the request is sent, update state again
                if (isMounted.current)
                  // only update if we are still mounted
                  setIsSending(false);

                const dataDelete = [...members];
                const index = oldData.tableData.id;
                dataDelete.splice(index, 1);
                setMembers([...dataDelete]);
              }).catch((error) => {
              })
          }}
          options={{
            headerStyle: {
              backgroundColor: "var(--c1)",
              color: "#FFF",
            },
            actionsColumnIndex: -1
          }}
          detailPanel={[
            {
              tooltip: "Show Details",
              render: (rowData) =>
                  <MemberTableDetailPanel
                      memberDetails={rowData}
                  />
              ,
            },
          ]}
        />

        {user.role.id <= ROLES.ADMIN &&
            <NarrowButtonWrapper>
              <NarrowButton
                  onClick={() => {
                    history.push(ROUTES.MEMBERS_FORM, { id: null});
                  }}
              >
                New Member
              </NarrowButton>
            </NarrowButtonWrapper>
        }
    </>)}
  else if (FetchState.ERROR === fetchState) return <ErrorPage />
  else if (FetchState.LOADING === fetchState) return <LoadingIcon />
}
